import { ShieldCheck, HardHat, AlertTriangle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/contexts/AuthContext";

export default function Login() {
  const { login, authError } = useAuth();

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-6">
      <div className="w-full max-w-md">
        <div className="bg-card border border-border rounded-xl shadow-lg p-8 text-center space-y-6">
          <div className="mx-auto h-14 w-14 rounded-xl bg-primary flex items-center justify-center">
            <HardHat className="h-7 w-7 text-primary-foreground" />
          </div>
          <div className="space-y-1">
            <h1 className="font-heading text-2xl font-semibold text-foreground">Outil SOP</h1>
            <p className="text-sm text-muted-foreground">
              Gestion des modes opératoires de sécurité (SOP)
            </p>
          </div>
          {authError && (
            <div
              className="flex items-start gap-2 rounded-lg border border-destructive/30 bg-destructive/10 p-3 text-left text-sm text-destructive"
              data-testid="login-access-denied-message"
            >
              <AlertTriangle className="h-4 w-4 mt-0.5 flex-shrink-0" />
              <span>{authError}</span>
            </div>
          )}
          <Button
            data-testid="google-login-button"
            className="w-full h-11"
            onClick={login}
          >
            <ShieldCheck className="h-4 w-4" />
            Se connecter avec Google
          </Button>
          <p className="text-xs text-muted-foreground">
            Réservé aux équipes terrain et préparation méthodes/sécurité du site.
          </p>
        </div>
      </div>
    </div>
  );
}
